import journal from "./meta/_journal.json";
import m0000 from "./0000_baseline.sql";

export default {
  journal,
  migrations: {
    m0000,
  },
};
